exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-bmfw {\n  width: 100%;\n}\n.page-bmfw .nav {\n  width: 100%;\n  height: 100vh;\n  background: #fff;\n}\n.page-bmfw .nav .nav-list-item {\n  width: 94%;\n  padding: 20px 3%;\n  text-align: center;\n  vertical-align: middle;\n}\n.page-bmfw .nav .nav-list-item span {\n  padding-top: 5px;\n  vertical-align: middle;\n  display: block;\n  color: #666666;\n  font-size: 14px;\n}\n.page-bmfw .nav .nav-list-item img {\n  width: 57px;\n  height: 57px;\n  vertical-align: middle;\n}\n", ""]);

// exports
